<template>
  <v-container fluid>
  <v-row>
    <v-col cols="12">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="6" md="3">
            <h5 class="primary--text"> Payment Exceptions </h5>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3" md="10">
            <div class="horizontal-container"  style="display: flex; justify-content: space-between;margin-left: auto;">
    <div class="item"><v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details color="primary"></v-text-field></div>
    <div class="item">
      <input type="date"  id="datepicker" v-model="filterDate" />
       </div>
    <div class="item"><v-btn  @click="downloadFilteredData">Download</v-btn></div>
  </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text> <!--headers id , eslipNumber , error , eslipAmount, dateCreated-->
         <v-data-table :headers="headers" :items="transactions" class="elevation-1" :search="search" disable-pagination :hide-default-footer="true">
          <template v-slot:[`header.id`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
           </template>
          <template v-slot:[`header.eSlipNumber`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
           </template>
           <template v-slot:[`header.error`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
           </template>
           <template v-slot:[`header.eslipAmount`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
           </template>
           <template v-slot:[`item.dateCreated`]="{ item }">
            {{item.dateCreated | prettyDate }}
          </template>
         </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
              prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    </v-col>
  </v-row>

  </v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'
  import _ from 'lodash'
  import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';

  export default {
    name: 'paymentexceptions',
    data: function () {
      return {
        search: '',
        headers: [
          { text: '#', value: 'id' },
          { text: 'ESLIP', value: 'eslipNumber' },
          { text: 'ERROR', value: 'error' },
          { text: 'AMOUNT', value: 'eslipAmount' },
          { text: 'DATE', value: 'dateCreated' }
        ],
        page: 1,
        totalPages: 0,
        datePickerFormat: 'yyyy-MM-dd',
        pageSize: 7,
        pageSizes: [5, 10],
        transactions: [],
        filteredTransactions: [],
        filterDate: null,
      }
    },
    mounted () {
      this.getSettlements();
      this.getFilteredSettlements () ;
    },
    computed: {
    filteredData() {
      // Filter data based on the selected
      if (this.filterDate) {
        return this.filteredTransactions.filter(item => item.dateCreated === this.filterDate);
      }
      return this.filteredTransactions;
    },
  },
    watch: {
      search: function (oldValue, newValue) {
        this.debouncedGetAnswer()
      }
    },
    methods: {

      getRequestParams (name, page, pageSize) {
        const params = {}
        if (page) {
          params.page = page - 1
        }
        if (pageSize) {
          params.size = pageSize
        }
        if (name) {
          params.benefactorName = name
        }
        return params
      },
      getFilteredSettlements () {
        const params = this.getRequestParams(this.search, this.page, this.pageSize)
        const url = config.serverURI + '/payment/exceptions/date'
        axios.get(url, { params })
          .then(response => {
          this.filteredTransactions = response.data
          })
          .catch(error => {
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
          })
        return this.filteredTransactions
      },
      getSettlements () {
        const params = this.getRequestParams(this.search, this.page, this.pageSize)
        const url = config.serverURI + '/payment/exceptions'
        axios.get(url, { params })
          .then(response => {
            console.log('Response', response.data)
          const { items, totalPages } = response.data
          this.transactions = items
          this.totalPages = totalPages
          })
          .catch(error => {
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
          })
        console.log('Transactions', this.transactions)
        return this.transactions
      },
      handlePageChange (value) {
        this.page = value
        this.getSettlements()
      },
      handlePageSizeChange (size) {
        this.pageSize = size
        this.page = 1
        this.getSettlements()
      },
      downloadFilteredData() {
        console.log(this.filterDate)
        const jsonData =  this.filteredTransactions;

      // Convert JSON array to worksheet
      const ws = XLSX.utils.json_to_sheet(jsonData);

      // Create a workbook and add the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Coffee-DSS-Payment-Exceptions");

      // Save the Excel file
      XLSX.writeFile(wb, "Payment-Exceptions" + Date.now() + ".xlsx");
    },
    },
    created: function () {
      this.debouncedGetAnswer = _.debounce(this.getSettlements, 1000)
    },

  }
  </script>
  <style>
  .horizontal-container {
  display: flex; /* Use flexbox for horizontal alignment */
}

.item {
  margin-right: 10px; /* Add spacing between items if needed */
  margin-left: auto;
}
  </style>
